var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"CourseText"}},[_c('div',{staticClass:"col-md-12",style:({ height: _vm.contentHeight - 100 + 'px' })},[_c('div',{staticClass:"chapters-text",domProps:{"innerHTML":_vm._s(_vm.text)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }